import React, { useState } from 'react';
import {
  Box,
  Text,
  Badge,
  Select,
  Flex,
  Stack
} from '@chakra-ui/react';
import { Truck } from 'lucide-react';
import getStatusColor from '../utils/StatusColor';
import InfoCard from 'components/Card/InfoCard';
import { useDispatch } from 'react-redux';
import { updateDeliveryStatusAction, fetchDeliveriesAction } from 'state/actions/deliveryActions';
import { useCustomNotification } from 'components/Toasts/OpenNotification';
import GradientButton from 'components/Buttons/GradientButton';

const ManageDelivery = ({ delivery: deliveryData, onClose }) => {
  const notify = useCustomNotification();
  const dispatch = useDispatch();

  const [status, setStatus] = useState(deliveryData?.status || '');
  const [originalStatus, setOriginalStatus] = useState(deliveryData?.status || '');

  // This is triggered when the user changes the status
  const handleStatusChange = (e) => {
    setStatus(e.target.value);
  };
 

  // This is triggered when the user clicks Save
  const handleSave = async () => {
    try {
      const response = await dispatch(updateDeliveryStatusAction(deliveryData.deliveryId, status));
      
      if (response.success) {
        notify({
          message: 'Delivery Status Updated',
          description: `Status changed to "${status}"`,
          type: 'success',
        });
         dispatch(fetchDeliveriesAction());
        onClose(); // Close the modal or drawer after save
      } else {
        notify({
          message: 'Failed to Update Status',
          description: response.error || 'An error occurred while updating status.',
          type: 'error',
        });
      }
    } catch (error) {
      notify({
        message: 'Error',
        description: error.message || 'Something went wrong while updating the status.',
        type: 'error',
      });
    }
  };

  // This is triggered when the user clicks Cancel
  const handleCancel = () => {
    setStatus(originalStatus); // Revert the status back to the original value
    onClose(); // Close the modal or drawer without saving
  };

  const isStatusLocked = ['Delivered', 'Canceled'].includes(status);

  return (
    <Flex direction="column" p={4}>
      <InfoCard
        heading="Manage Delivery Status"
        icon={<Truck />}
        headingFontSize="md"
        headingFontWeight="500"
        headingColor="gray.500"
      >
        <Box mt={4}>
          <Text fontWeight="500" mb={1} color="gray.600">Current Status</Text>
          <Badge colorScheme={getStatusColor(status)} mb={4}>
            {status}
          </Badge>

          <Text fontWeight="500" mb={1} color="gray.600">Update Status</Text>
          <Select
            placeholder="Select status"
            value={status}
            onChange={handleStatusChange}
            isDisabled={isStatusLocked}
          >
            <option value="Pending">Pending</option>
            <option value="In Progress">In Progress</option>
            <option value="Completed">Completed</option>
            <option value="Failed">Failed</option>
          </Select>

          {isStatusLocked && (
            <Text color="red.500" fontSize="xs" mt={2}>
              Status updates are disabled once the delivery is completed or canceled.
            </Text>
          )}
        </Box>
      </InfoCard>

      {/* Footer with Cancel and Save buttons */}
      <Stack direction="row" spacing={4} justifyContent="flex-end" mt={80}>
        <GradientButton onClick={handleCancel} fontSize="15px" width="100px" height="40px">
          Cancel
        </GradientButton>
        <GradientButton onClick={handleSave} fontSize="15px" width="100px" height="40px">
          Save
        </GradientButton>
      </Stack>
    </Flex>
  );
};

export default ManageDelivery;
